import React, { useState, useEffect } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import cityProfileImage from '../../../assests/val/IMG-20241001-WA0006.jpg';
import cityProfileImage1 from '../../../assests/val/IMG-20241001-WA0007.jpg';
import cityProfileImage2 from '../../../assests/val/IMG-20241001-WA0008.jpg';
import cityProfileImage3 from '../../../assests/val/IMG-20241001-WA0009.jpg';
import cityProfileImage4 from '../../../assests/val/IMG-20241001-WA0010.jpg';
import cityProfileImage5 from '../../../assests/val/IMG-20241001-WA0011.jpg';

import cityProfileImage6 from '../../../assests/val/val/1.jpg';
import cityProfileImage7 from '../../../assests/val/val/2.jpg';
import cityProfileImage8 from '../../../assests/val/val/3.jpg';
import cityProfileImage9 from '../../../assests/val/val/4.jpg';
import cityProfileImage10 from '../../../assests/val/val/5.jpg';
import cityProfileImage11 from '../../../assests/val/val/6.jpg';
import cityProfileImage12 from '../../../assests/val/val/7.jpg';
import cityProfileImage13 from '../../../assests/val/val/8.jpg';
import cityProfileImage14 from '../../../assests/val/val/9.jpg';
import cityProfileImage15 from '../../../assests/val/val/10.jpg';
import cityProfileImage16 from '../../../assests/val/val/11.jpg';
import cityProfileImage17 from '../../../assests/val/val/12.jpg';
import cityProfileImage18 from '../../../assests/val/val/13.jpg';
import cityProfileImage19 from '../../../assests/val/val/14.jpg';
import cityProfileImage20 from '../../../assests/val/val/15.jpg';
import cityProfileImage21 from '../../../assests/val/val/16.jpg';

import cityProfileImage22 from '../../../assests/val/val/17.jpg';
import cityProfileImage23 from '../../../assests/val/val/18.jpg';
import cityProfileImage24 from '../../../assests/val/val/19.jpg';
import cityProfileImage25 from '../../../assests/val/val/20.jpg';
import cityProfileImage26 from '../../../assests/val/val/21.jpg';
import cityProfileImage27 from '../../../assests/val/val/22.jpg';
import cityProfileImage28 from '../../../assests/val/val/23.jpg';
import cityProfileImage29 from '../../../assests/val/val/24.jpg';
import { useSelector } from 'react-redux';


const photos = [

  { src: cityProfileImage, width: 4, height: 3 },
  { src: cityProfileImage1, width: 4, height: 3 },
  { src: cityProfileImage2, width: 4, height: 3 },
  { src: cityProfileImage3, width: 4, height: 3 } , 
  { src: cityProfileImage4, width: 4, height: 3 },
  { src: cityProfileImage5, width: 4, height: 3 }, 
  { src: cityProfileImage6, width: 4, height: 3 }, 
  { src: cityProfileImage7, width: 4, height: 3 }, 
  { src: cityProfileImage8, width: 4, height: 3 }, 
  { src: cityProfileImage9, width: 4, height: 3 }, 
  { src: cityProfileImage10, width: 4, height: 3 }, 
  { src: cityProfileImage11, width: 4, height: 3 }, 
  { src: cityProfileImage12, width: 4, height: 3 }, 
  { src: cityProfileImage13, width: 4, height: 3 }, 

  { src: cityProfileImage14, width: 3, height: 3 }, 
  { src: cityProfileImage15, width: 3, height: 3 }, 
  { src: cityProfileImage16, width: 3, height: 3 }, 
  { src: cityProfileImage17, width: 3, height: 3 }, 
  { src: cityProfileImage18, width: 3, height: 3 }, 
  { src: cityProfileImage19, width: 3, height: 3 }, 
  { src: cityProfileImage20, width: 3, height: 3 }, 
  { src: cityProfileImage21, width: 3, height: 3 }, 
  { src: cityProfileImage22, width: 3, height: 3 }, 
  { src: cityProfileImage23, width: 3, height: 3 }, 
  { src: cityProfileImage24, width: 3, height: 3 }, 
  { src: cityProfileImage25, width: 3, height: 3 }, 
  { src: cityProfileImage26, width: 3, height: 3 }, 
  { src: cityProfileImage27, width: 3, height: 3 }, 
  { src: cityProfileImage28, width: 3, height: 3 }, 
  { src: cityProfileImage29, width: 3, height: 3 }, 


];


function Slidervel({ onImageSelect }) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const lang = useSelector((state) => state.lang.lang);

  useEffect(() => {
    setLoaded(false);
  }, [photoIndex]);

  const handleImageLoad = () => {
    setLoaded(true);
  };

  const openLightbox = () => {
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const handleThumbnailClick = (index) => {
    setPhotoIndex(index);

    if (index >= 0) {
      onImageSelect(photos[index].src); 
    }
  };

  return (
    <div className="photo-gallery container">
      <div className="main-image d-flex justify-content-center">
        <img
          src={photos[photoIndex].src}
          alt="Main"
          onLoad={handleImageLoad}
          className={loaded ? 'loaded' : ''}
          onClick={openLightbox}
        />
      </div>

      <div className="section-title text-center mt-4" style={{display:'none'}}>
      <h3 className="group-title" style={{fontFamily:'cairo'}}>{lang === 'en' ? 'Sample full project' : 'عينة مشروع كاملة'}</h3>
      </div>

      <div className="thumbnail-gallery" style={{display:'none'}}>
        {photos.slice(0, 0).map((photo, index) => (
          <div key={index} className="thumbnail-item">
            <img
              src={photo.src}
              alt={`Thumbnail ${index + 1}`}
              onClick={() => handleThumbnailClick(index)}
              className={photoIndex === index ? 'active-thumbnail' : ''}
            />
          </div>
        ))}
      </div>
      <div className="section-title text-center mt-4">
      <h3 className="group-title" style={{fontFamily:'cairo'}}>{lang === 'en' ? 'Designs that suit your style' : ' تصميمات تناسب ذوقك '}</h3>
      </div>

      <div className="thumbnail-gallery">
        {photos.slice(0).map((photo, index) => (
          <div key={index + 0} className="thumbnail-item">
            <img
              src={photo.src}
              alt={`Thumbnail ${index + 10}`}
              onClick={() => handleThumbnailClick(index + 0)}
              className={photoIndex === index + 0 ? 'active-thumbnail' : ''}
            />
          </div>
        ))}
      </div>

      {isOpen && (
        <Lightbox
          mainSrc={photos[photoIndex].src}
          nextSrc={photos[(photoIndex + 1) % photos.length].src}
          prevSrc={photos[(photoIndex + photos.length - 1) % photos.length].src}
          onCloseRequest={closeLightbox}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % photos.length)
          }
        />
      )}
    </div>
  );
}
export default Slidervel;


